import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { OrderProvider } from './pos/contexts/OrderContext';
import GlobalSpinner from './pos/GlobalSpinner/GlobalSpinner';

// Context Providers (should not be lazy)
import ProductsContextProvider from './pos/contexts/ProductsContext';
import CartContextProvider from './pos/contexts/CartContext';
import CategoryContextProvider from './pos/contexts/CategoryContext';
import GlobalSpinnerContextProvider from './pos/contexts/GlobalSpinnerContext';

// Lazy-loaded Pages

const Login = lazy(() => import('./pos/manage/LoginScreen'));
const DocumentEditor = lazy(() => import('./admission/documenteditor'));
const AdmissionForm = lazy(() => import('./admission/AdmissionEdit'));
const AdmissionUpdate = lazy(() => import('./admission/AdmissionUpdate'));
const AdmissionList = lazy(() => import('./admission/admissionlist'));
const ClinicalDocuments = lazy(() => import('./admission/clinicaldocumentlist'));
const DocumentManager = lazy(() => import('./admission/documentcategorymaster'));
const SignatureManager = lazy(() => import('./admission/signatureimagemaster'));
const DocumentUpload = lazy(() => import('./admission/patientdocumentsupload'));
const LabReports = lazy(() => import('./admission/patientlabreports'));
const OtherDocuments = lazy(() => import('./admission/patientotherdocuments'));
const DocumentViewer = lazy(() => import('./admission/patientdocumentviewer'));
const DocumentScroll = lazy(() => import('./admission/patientdocumentscroll'));
const DischargeNote = lazy(() => import('./admission/patientdischargenote'));
const DischargeHeadMaster = lazy(() => import('./admission/dischargeheadermaster'));
const MedicineEntry = lazy(() => import('./admission/medicineentryform'));
const DischargedList = lazy(() => import('./admission/admissionlistdischarged'));
const TestWriting = lazy(() => import('./admission/testwriting'));

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Suspense fallback={<div style={{ textAlign: 'center' }}><GlobalSpinner /></div>}>
        <HelmetProvider>
          <GlobalSpinnerContextProvider>
            <ProductsContextProvider>
              <CartContextProvider>
                <OrderProvider>
                  <CategoryContextProvider>
                    <Routes>
                      <Route path="/" element={<Navigate to="/login" replace />} />
                      <Route path="/login" element={<Login />} />

                      {/* Admission */}
                      <Route path="/home" element={<AdmissionList />} />
                      <Route path="/editor" element={<DocumentEditor />} />
                      <Route path="/admissionlist" element={<AdmissionList />} />
                      <Route path="/admissionform" element={<AdmissionForm />} />
                      <Route path="/documentlist" element={<ClinicalDocuments />} />
                      <Route path="/documentmanager" element={<DocumentManager />} />
                      <Route path="/signaturemanager" element={<SignatureManager />} />
                      <Route path="/documentupload" element={<DocumentUpload />} />
                      <Route path="/labreports" element={<LabReports />} />
                      <Route path="/otherdocuments" element={<OtherDocuments />} />
                      <Route path="/documentsviewer" element={<DocumentViewer />} />
                      <Route path="/documentscroll" element={<DocumentScroll />} />
                      <Route path="/dischargenote" element={<DischargeNote />} />
                      <Route path="/dischargehead" element={<DischargeHeadMaster />} />
                      <Route path="/medicineentry" element={<MedicineEntry />} />
                      <Route path="/dischargedlist" element={<DischargedList />} />
                      <Route path="/testwriting" element={<TestWriting />} />
                      <Route path="/admissionupdate" element={<AdmissionUpdate />} />

                    </Routes>
                  </CategoryContextProvider>
                </OrderProvider>
              </CartContextProvider>
            </ProductsContextProvider>
          </GlobalSpinnerContextProvider>
        </HelmetProvider>
      </Suspense>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
